<template>
  <div>
    <!-- PracticeScales already includes its own Header and Footer; render it directly -->
    <PracticeScales />
  </div>
</template>
<script setup>
import PracticeScales from './PracticeScales.vue';
</script>
